import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081';

const ShopByIdPage = () => {
  const { shopId } = useParams();
  const history = useHistory();

  useEffect(() => {
    let cancelled = false;
    const resolve = async () => {
      if (!shopId) return;
      try {
        const res = await axios.get(`${API_BASE_URL}/api/vendor/shops/${shopId}`);
        if (cancelled) return;
        if (res.data && res.data.success && res.data.data) {
          const shop = res.data.data;
          const code = shop.shopUniqueCode || shop.shopCode || shop.code || shop.shop_code || shop.shopCodeString || shop.shopUniqueCode;
          if (code) {
            history.replace(`/${code}`);
            return;
          }
        }
        // Fallback: show not found
        history.replace(`/`);
      } catch (err) {
        console.error('Error resolving shop by id:', err);
        history.replace(`/`);
      }
    };

    resolve();

    return () => { cancelled = true; };
  }, [shopId, history]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-lg text-gray-600">Resolving shop...</div>
    </div>
  );
};

export default ShopByIdPage;
